import React from "react";
import Signup from "Pages/Signup";

const Signuptheme = () => {
  return (
    <React.Fragment>
      <Signup />
    </React.Fragment>
  );
};

export default Signuptheme;
